import { render, staticRenderFns } from "./CodemirrorEditor.vue?vue&type=template&id=6a0397b9&"
import script from "./CodemirrorEditor.vue?vue&type=script&lang=js&"
export * from "./CodemirrorEditor.vue?vue&type=script&lang=js&"
import style0 from "./CodemirrorEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports